import { ReportConfiguration } from "@idw-types/data/report-configuration/report-configuration";

export enum ReportConfigurationsActionTypes {
    // Report Configurations
    SET_REPORT_CONFIGURATIONS_LOADING = "SET_REPORT_CONFIGURATIONS_LOADING",
    SET_REPORT_CONFIGURATIONS = "SET_REPORT_CONFIGURATIONS",
    ADD_REPORT_CONFIGURATION = "ADD_REPORT_CONFIGURATION",
    UPDATE_REPORT_CONFIGURATIONS = "UPDATE_REPORT_CONFIGURATIONS"
}

// Report Configurations
type SetReportConfigurationsLoadingAction = {
    type: ReportConfigurationsActionTypes.SET_REPORT_CONFIGURATIONS_LOADING;
    payload: { isLoading: boolean; }
};

export const setReportConfigurationsLoading = (isLoading: boolean): SetReportConfigurationsLoadingAction => ({
    type: ReportConfigurationsActionTypes.SET_REPORT_CONFIGURATIONS_LOADING,
    payload: { isLoading }
});

type SetReportConfigurationsAction = {
    type: ReportConfigurationsActionTypes.SET_REPORT_CONFIGURATIONS;
    payload: { reportConfigurations: Array<ReportConfiguration>; }
}

export const setReportConfigurations = (reportConfigurations: Array<ReportConfiguration>): SetReportConfigurationsAction => ({
    type: ReportConfigurationsActionTypes.SET_REPORT_CONFIGURATIONS,
    payload: { reportConfigurations }
});

export type ReportConfigurationsActions =
    // Report Configurations
    SetReportConfigurationsLoadingAction |
    SetReportConfigurationsAction